import React from 'react';
import styles from './style.module.scss';
import CardStats from '../HeroSection/CardStats';
import { useTranslation } from 'react-i18next';

const HeroSectionEmployers = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.textInfo}>
          <h1>{t('h1_success_employers')}</h1>
          <p>{t('h1_description_employers')}</p>
        </div>
        <CardStats />
      </div>
    </section>
  );
};

export default HeroSectionEmployers;
